/*
Important: The data and text in this file are not covered by the GPL
Descriptions and some names are copyright and owned by Edge Studio, no copyright
claim is intended by application author(s)
*/
export const AdversaryTypes: string[] = [
    "Minion",
    "Rival",
    "Nemesis",
]